import AccordionBlock from 'components/blocks/Accordion';
import { ActionCardsBlock } from 'components/blocks/ActionCards';
import AuthorInfo from 'components/blocks/AuthorInfo';
import ContactCards from 'components/blocks/ContactCards';
import ContentTabs from 'components/blocks/ContentTabs';
import CookiesList from 'components/blocks/CookiesList';
import CountdownClockBlock from 'components/blocks/CountdownClock';
import CtaBannersBlock from 'components/blocks/CtaBanners';
import FeatureBlock from 'components/blocks/Feature';
import FeatureVideoBlock from 'components/blocks/FeatureVideo';
import ImageAndCtaCardsBlock from 'components/blocks/ImageAndCtaCards';
import ImageBreakBlock from 'components/blocks/ImageBreak';
import ImageGalleryBlock from 'components/blocks/ImageGallery';
import InfoBannerBlock from 'components/blocks/InfoBanner';
import InfoCardsBlock from 'components/blocks/InfoCards';
import {
  DocumentDownloadLinkListWithPagination,
  RelatedContentCardListWithPagination,
} from 'components/blocks/ListWithPagination';
import MiniGuideBlock from 'components/blocks/MiniGuide';
import ProductCardsBlock from 'components/blocks/ProductCards';
import {
  DetailedRelatedContentBlock,
  ExpandableRelatedContentCards,
} from 'components/blocks/RelatedContent';
import { RichTextBlock } from 'components/blocks/RichText';
import ShareWidget from 'components/blocks/ShareWidget';
import SoundCloudPlayerBlock from 'components/blocks/SoundCloudPlayer';
import { SplitInfoCardBlock } from 'components/blocks/SplitInfoCard';
import TableBlock from 'components/blocks/Table';
import TestimonialBlock from 'components/blocks/Testimonial';
import TestimonialWithImageBlock from 'components/blocks/TestimonialWithImage';
import { m, mapBlocksInternal, MappingEntry } from './mappingUtils';

/**
 * This is the main mapping from blocks in ContentStack to React components.
 *
 * The key should be the name of the block in ContentStack and the value is the corresponding
 * component, where the Props for the component match the block returned by the graphql query.
 *
 * The `m` function is a helper that ensures that the key and props correspond as expected.
 */
const MAPPING: MappingEntry[] = [
  m('accordion', AccordionBlock),
  m('action_cards', ActionCardsBlock),
  m('author_info', AuthorInfo),
  m('contact_cards', ContactCards),
  m('content_tabs', ContentTabs),
  m('cookies_list', CookiesList),
  m('countdown_clock', CountdownClockBlock),
  m('cta_banners', CtaBannersBlock),
  m('detailed_related_content', DetailedRelatedContentBlock),
  m(
    'document_download_link_list_with_pagination',
    DocumentDownloadLinkListWithPagination
  ),
  m('expandable_related_content_cards', ExpandableRelatedContentCards),
  m('feature', FeatureBlock),
  m('feature_video', FeatureVideoBlock),
  m('image_and_cta_cards', ImageAndCtaCardsBlock),
  m('image_break', ImageBreakBlock),
  m('image_gallery', ImageGalleryBlock),
  m('info_banner', InfoBannerBlock),
  m('info_cards', InfoCardsBlock),
  m('mini_guide', MiniGuideBlock),
  m('product_cards', ProductCardsBlock),
  m('related_content_card_list_with_pagination', RelatedContentCardListWithPagination),
  m('rich_text', RichTextBlock),
  m('social_media_share', ShareWidget),
  m('soundcloud_player', SoundCloudPlayerBlock),
  m('split_info_card', SplitInfoCardBlock),
  m('table', TableBlock),
  m('testimonial', TestimonialBlock),
  m('testimonial_with_image', TestimonialWithImageBlock),
];

const mapBlocks = mapBlocksInternal(MAPPING);
export default mapBlocks;
